// src/pages/Dashboard.tsx
import { Navigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import PlatformDashboard from "../platform/PlatformDashboard";
import OrganizationDashboard from "../organization/OrganizationDashboard";

const Dashboard = () => {
  const { user, loading } = useAuth();
  const [searchParams] = useSearchParams();
  const querySection = searchParams.get("section");

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;

  if (user.role === "PlatformOwner") {
    return user.activeOrganization ? (
      <OrganizationDashboard />
    ) : (
      <PlatformDashboard />
    );
  }

  if (
    user.role === "OrganizationOwner" ||
    user.role === "Admin" ||
    user.role === "Manager" ||
    user.role === "Receptionist"
  ) {
    return <OrganizationDashboard />;
  }

  if (user.role === "Staff") {
    if (!querySection) {
      return <Navigate to="/dashboard?section=clients" replace />;
    }
    return <OrganizationDashboard />;
  }

  return <div>Unauthorized role</div>;
};

export default Dashboard;